import React, { useEffect, useState } from "react";

const StreamText = ({
  fullText,
  setIsMessageChanged,
  speed = 100,
  setIsLoading,
}) => {
  const [displayedText, setDisplayedText] = useState("");
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [isCompleted, setIsCompleted] = useState(false);

  const words = fullText.split(" ");

  useEffect(() => {
    // Reset when fullText changes
    setDisplayedText("");
    setCurrentWordIndex(0);
    setIsCompleted(false);
    setIsLoading(true);
  }, [fullText, setIsLoading]);

  useEffect(() => {
    if (currentWordIndex < words.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(
          (prev) => prev + (prev ? " " : "") + words[currentWordIndex]
        );
        setIsMessageChanged(words[currentWordIndex]);
        setCurrentWordIndex((prev) => prev + 1);
      }, speed);

      return () => clearTimeout(timeout);
    } else if (!isCompleted) {
      setIsCompleted(true);
      setIsLoading(false);
    }
  }, [
    currentWordIndex,
    words,
    speed,
    setIsMessageChanged,
    setIsLoading,
    isCompleted,
  ]);

  return <p>{displayedText}</p>;
};

export default StreamText;
